import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Employee, LoggerService } from '../../../../shared/sdk';

@Component({
  selector: 'app-dlg-vehicle-document-grid',
  templateUrl: './dlg-vehicle-document-grid.component.html',
  styleUrls: ['./dlg-vehicle-document-grid.component.scss'],
})
export class DlgVehicleDocumentGridComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<DlgVehicleDocumentGridComponent, any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    protected logger: LoggerService,
  ) {}

  ngOnInit() {}
}
